<script>
  /* Import components  */
  import MainComplaintForm from "./MainComplaintForm.svelte";

  /* Import packages */
  import Select from "svelte-select";
  import { onMount } from "svelte";
  import { Circle3 } from "svelte-loading-spinners";

  import loadOptions from './clients.js';
  const optionIdentifier = 'id';
  const getOptionLabel = (option) => option.company;
  const getSelectionLabel = (option) => option.company;

  /* Import props */
  export let params;
  export let currentRoute;
  let type = 'complaint'

  /* Declare variables */
  let viewComplaintForm = false;
  let selectedClient = undefined;

  /* Declare functions */

  /* Lauch when select client in Select */
  function handleSelectClient(selectedVal) {
    selectedClient = selectedVal.detail;
    viewComplaintForm = true;
  }

  /* Lauch when creal client in Select */
  function handleClearClient() {
    viewComplaintForm = false;
  }

  /* Get clients from API */
  const fetchData = async () => {
    const request = await fetch(`${__myapp.env.API_URL}client`);
    return await request.json();
  };

  const request = fetchData();
</script>

<style>
  .themed {
    --borderRadius: 0px;
    --height: 50px;
    --border: 1px solid #dae1e3;
    --inputFontSize: 16px;
    --borderFocusColor: #80bdff;
    --placeholderColor: #a9a9a9;
    --listBorderRadius: 0px;
  }
</style>

<section id="denuncia" class="section mx-5">
  <div class="container">
    <h2 class="text-center font-weight-600 text-uppercase mb-5">
      Selección de empresa
    </h2>

    {#await request}
      <div class="d-flex justify-content-center">
        <Circle3
          size="60"
          ballTopLeft="#4843d2"
          ballTopRight="#4843d2"
          ballBottomLeft="#4843d2"
          ballBottomRight="#4843d2"
          unit="px" />
      </div>
    {:then result}
      <div class="themed">
        <Select
          {loadOptions}
          {optionIdentifier} {getSelectionLabel} {getOptionLabel}
          on:select={handleSelectClient}
          on:clear={handleClearClient}
          placeholder="Seleccione la compañía" />
      </div>
    {:catch error}
      <div class="alert alert-danger" style="border-radius:0px" role="alert">
        No hemos podido obtener la información, contacta al administrador
      </div>
      <h1>Error</h1>
    {/await}

    <br />

    {#if viewComplaintForm && selectedClient}
      <MainComplaintForm client={selectedClient} {type} />
    {/if}

  </div>
</section>
